import { Page } from "components/page";
import { type GetStaticProps, type NextPage } from "next";
import { type MDXRemoteSerializeResult } from "next-mdx-remote";
import { serialize } from "next-mdx-remote/serialize";
import rehypeHighlight from "rehype-highlight";
import rehypeSlug from "rehype-slug";
import remarkGfm from "remark-gfm";
import React from "react";
import { LegalPage } from "components/legal";
import { currentVersion } from "data/legal/cookie-policy";

type PageProps = {
  documentSource: MDXRemoteSerializeResult;
};

const PrivacyPolicy: NextPage<Readonly<PageProps>> = ({ documentSource }) => {
  return (
    <Page
      title="Cookie Policy"
      description="At Hightouch, accessible from hightouch.com, one of our main priorities is the privacy of our visitors."
      footerOptions={{ hideCta: true }}
    >
      <LegalPage
        title="Cookie Policy"
        lastUpdatedDate={currentVersion.date}
        mdxSource={documentSource}
        currentVersionSlug="cookie-policy"
      />
    </Page>
  );
};

export const getStaticProps: GetStaticProps<PageProps> = async () => {
  const mdx = currentVersion.content;

  const documentSource = await serialize(mdx, {
    mdxOptions: {
      rehypePlugins: [rehypeSlug, rehypeHighlight],
      remarkPlugins: [remarkGfm],
      format: "md",
    },
  });

  return { props: { documentSource } };
};

export default PrivacyPolicy;
